import { getApiBaseUrl } from "../config/apiBase";
import { apiFetch } from "../config/apiFetch";

async function parseBody(res: Response): Promise<{ error?: string; [k: string]: unknown }> {
  const text = await res.text();
  if (!text) return {};
  try {
    return JSON.parse(text) as { error?: string };
  } catch {
    return {};
  }
}

function geoAdminDistrictPathId(id: string | number) {
  return encodeURIComponent(String(id));
}

async function adminFetch(path: string, init?: RequestInit) {
  const res = await apiFetch(`${getApiBaseUrl()}${path}`, {
    ...init,
    headers: { "Content-Type": "application/json", ...init?.headers },
  });
  const body = await parseBody(res);
  if (!res.ok) {
    const msg = typeof body.error === "string" ? body.error : `Request failed (${res.status})`;
    throw new Error(msg);
  }
  return body;
}

export function createGeoAdminDistrict(payload: {
  districtKey: string;
  registrationDistrictCode: string;
  registrationDistrictName: string;
}) {
  return adminFetch("/api/geo/admin/districts", { method: "POST", body: JSON.stringify(payload) }) as Promise<{ id: string }>;
}

export function updateGeoAdminDistrict(
  id: string | number,
  payload: { districtKey: string; registrationDistrictCode: string; registrationDistrictName: string },
) {
  return adminFetch(`/api/geo/admin/districts/${geoAdminDistrictPathId(id)}`, {
    method: "PATCH",
    body: JSON.stringify(payload),
  }) as Promise<{
    ok: boolean;
  }>;
}

export function deleteGeoAdminDistrict(id: string | number) {
  return adminFetch(`/api/geo/admin/districts/${geoAdminDistrictPathId(id)}`, { method: "DELETE" }) as Promise<{ ok: boolean }>;
}

export function createGeoAdminMandal(payload: { districtId: string | number; mandalCode: string; mandalName: string }) {
  return adminFetch("/api/geo/admin/mandals", { method: "POST", body: JSON.stringify(payload) }) as Promise<{ id: number }>;
}

export function updateGeoAdminMandal(
  id: number,
  payload: { districtId: string | number; mandalCode: string; mandalName: string },
) {
  return adminFetch(`/api/geo/admin/mandals/${id}`, { method: "PATCH", body: JSON.stringify(payload) }) as Promise<{
    ok: boolean;
  }>;
}

export function deleteGeoAdminMandal(id: number) {
  return adminFetch(`/api/geo/admin/mandals/${id}`, { method: "DELETE" }) as Promise<{ ok: boolean }>;
}

export function createGeoAdminVillage(payload: { mandalId: number; villageName: string; villageCode: string }) {
  return adminFetch("/api/geo/admin/villages", { method: "POST", body: JSON.stringify(payload) }) as Promise<{ id: number }>;
}

export function updateGeoAdminVillage(
  id: number,
  payload: { mandalId: number; villageName: string; villageCode: string },
) {
  return adminFetch(`/api/geo/admin/villages/${id}`, { method: "PATCH", body: JSON.stringify(payload) }) as Promise<{
    ok: boolean;
  }>;
}

export function deleteGeoAdminVillage(id: number) {
  return adminFetch(`/api/geo/admin/villages/${id}`, { method: "DELETE" }) as Promise<{ ok: boolean }>;
}
